module.exports = __webpack_public_path__ + "static/media/currentubication.1b3a8bac.gif";